export default {"src":"/_next/static/media/prebidsIcon.f7c3b094.svg","height":24,"width":24};